import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Stage } from '@pixi/react';
import { useStore } from '@/app/providers/StoreProvider';
import { GameCanvas } from '@/entities/game/ui/GameCanvas';
import { useWindowSize } from '@/shared/hooks/useWindowSize';
import { getDevice } from '@/shared/utils/window';
import {AREA, GAME_LAYOUT} from "@/entities/game/model/gameLayout";

export const StageContainer = observer(() => {
  const size = useWindowSize();
  const { gameStore } = useStore();

  const device =  getDevice();

  const baseW = AREA.baseWidth;
  const baseH = AREA.baseHeight;

  const availableWidth = size.width - GAME_LAYOUT.padding;
  const availableHeight = size.height - (device == 'mobile'?GAME_LAYOUT.topPadding:0) - GAME_LAYOUT.bottomPadding - GAME_LAYOUT.hudH;

  const scaleX = availableWidth / baseW;
  const scaleY = availableHeight / baseH;

  const scale = Math.min(scaleX, scaleY);

  const stageWidth = baseW * scale;
  const stageHeight = baseH * scale;

  useEffect(() => {
    gameStore.scale = scale;
    AREA.width = stageWidth;
    AREA.height = stageHeight;
    AREA.x = 0;
    AREA.y = GAME_LAYOUT.hudH;

    gameStore.initGame(size);
  }, [size.height, size.width]);

  useEffect(() => {
    return () => {
      gameStore.setGameStop();
    };
  }, []);

  return (
    <Stage
      width={stageWidth}
      height={stageHeight + GAME_LAYOUT.hudH}
      options={{ backgroundColor: 0xffffff }}
      onClick={() => gameStore.setGameStart()}
    >
      <GameCanvas
        size={{ width: stageWidth, height: stageHeight }}
        game={gameStore}
      />
    </Stage>
  );
});
